import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 624 448",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("ellipse", {
			id: "a",
			cx: 49.888,
			cy: 48.474,
			rx: 20.5,
			ry: 49
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			id: "c",
			cx: 35.493,
			cy: 53.166,
			rx: 20.5,
			ry: 49
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			id: "e",
			cx: 45.403,
			cy: 26.43,
			rx: 17.767,
			ry: 42.468
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			x1: "65.517%",
			y1: "36.623%",
			x2: "51.724%",
			y2: "52.675%",
			id: "g",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#001E87",
				stopOpacity: .5,
				offset: "0%"
			}), /* @__PURE__ */ _jsx("stop", {
				stopColor: "#001E87",
				stopOpacity: 0,
				offset: "100%"
			})]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			x: "-11.2%",
			y: "-46.6%",
			width: "122.3%",
			height: "193.1%",
			filterUnits: "objectBoundingBox",
			id: "h",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 2,
					in: "SourceAlpha",
					result: "shadowOffsetOuter1"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 6,
					in: "shadowOffsetOuter1",
					result: "shadowBlurOuter1"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					values: "0 0 0 0 0.0117647059 0 0 0 0 0.0823529412 0 0 0 0 0.22745098 0 0 0 0.188947771 0",
					in: "shadowBlurOuter1",
					result: "shadowMatrixOuter1"
				}),
				/* @__PURE__ */ _jsxs("feMerge", { children: [/* @__PURE__ */ _jsx("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ _jsx("feMergeNode", { in: "SourceGraphic" })] })
			]
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(191 85)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						fill: "#EDF1FF",
						width: 242,
						height: 140,
						rx: 10
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						x: 103,
						y: 52,
						width: 36,
						height: 36,
						rx: 5
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M128.714 66.352h-15.428c-.71 0-1.286-.537-1.286-1.194 0-.656.576-1.194 1.286-1.194h15.428c.71 0 1.286.538 1.286 1.194 0 .657-.576 1.194-1.286 1.194zM112 70.106c0-.657.576-1.194 1.286-1.194h8.571c.71 0 1.286.537 1.286 1.194 0 .657-.576 1.194-1.286 1.194h-8.571c-.71 0-1.286-.537-1.286-1.194zm13.714-.019c0-.656.576-1.194 1.286-1.194h1.714c.71 0 1.286.538 1.286 1.194 0 .657-.576 1.194-1.286 1.194H127c-.71 0-1.286-.537-1.286-1.194zm-12.428 3.587h15.428c.71 0 1.286.538 1.286 1.194 0 .657-.576 1.194-1.286 1.194h-15.428c-.71 0-1.286-.537-1.286-1.194 0-.656.576-1.194 1.286-1.194z",
						fill: "#546ACD"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M204.5 397.148c10.825 18.441-8.5 25.167-11.5 27 30.5-11 49.5-27 39.5-49.5s-34.926-36.5-78-58c-36.289-18.113-43.017-65.682-41.247-87.096.099-1.191-2.704-2.36-3.334-1.344C82.974 271.66 82.58 331.663 126 357.148c46 27 67.675 21.56 78.5 40z",
				fill: "#D9E0FF",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M277.344 353.111c20.395-18.019 44.436-15.862 56.193-16.13-1.31 5.837-3.957 9.784-10.958 18.562-7 8.777-18.468 17.281-33.006 17.052 7.892 19.794-25.668 44.164-28.931 46.768a.385.385 0 01-.159.191c-.17.088-.105.019.159-.191 1.543-3.328-8.087-44.35 16.702-66.252z",
				fill: "#7057FF",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M341 427.621c0 9.179-44.832 16.62-100.135 16.62-14.477 0-28.237-.51-40.663-1.427-17.59 3.207-41.739 5.186-68.387 5.186-23.068 0-44.263-1.483-60.952-3.962-6.067.575-12.726.892-19.713.892C22.9 444.93 0 439.742 0 433.343c0-5.915 19.57-10.795 44.844-11.499 16.067-5.869 48.98-9.891 86.971-9.891 17.73 0 34.353.876 48.675 2.407 16.786-2.109 37.7-3.36 60.375-3.36C296.168 411 341 418.441 341 427.621z",
				fill: "#03153A"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(102 344)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "b",
					fill: "#fff",
					children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
				}), /* @__PURE__ */ _jsx("ellipse", {
					fill: "#A5E7DB",
					fillRule: "nonzero",
					mask: "url(#b)",
					transform: "rotate(-47.222 60.076 37.464)",
					cx: 60.076,
					cy: 37.464,
					rx: 20.5,
					ry: 49
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(133 325)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "d",
					fill: "#fff",
					children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#c" })
				}), /* @__PURE__ */ _jsx("ellipse", {
					fill: "#6FBDB0",
					fillRule: "nonzero",
					mask: "url(#d)",
					transform: "rotate(-19.227 49.656 48.226)",
					cx: 49.656,
					cy: 48.226,
					rx: 20.5,
					ry: 49
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(106 390)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "f",
					fill: "#fff",
					children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#e" })
				}), /* @__PURE__ */ _jsx("ellipse", {
					fill: "#CAF3EC",
					fillRule: "nonzero",
					mask: "url(#f)",
					transform: "rotate(-77.777 48.155 13.724)",
					cx: 48.155,
					cy: 13.724,
					rx: 17.767,
					ry: 42.468
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M500.61 435.269c22.026-19.746-28.897-15.82-54.771-15.82-25.873 0-90.839-3.363-90.839 8.313 0 11.677 27.144 1.668 59.446 7.507 50.763 9.174 60.115 23.352 86.164 0z",
				fill: "#03153A",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M445.5 417.148c-5.494 5.387-6.919 8.445-7.038 10.566-.056 1.006-1.097 1.656-1.776.913-12.706-13.897-9.958-28.068 2.283-42.719 12.98-15.535 18.24-13.175 51.222-30.967 32.982-17.791 41.741-52.917 39.095-62.579 26.915 38.297 16.853 79.924-18.876 99.29-35.73 19.366-55.731 16.496-64.91 25.496z",
				fill: "#D9E0FF",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M419.353 414.192c.215.442.432.765.647.956-.217-.319-.433-.638-.647-.956-3.174-6.534-5.687-39.071 12.147-55.544 19.04-17.587 54.347-28.257 112.5-42.5 54.191-13.273 92.051-43.057 75.919-93.584-.374-1.17-1.821-.727-1.578.478 6.522 32.235 1.705 66.06-71.841 84.606-82.671 20.847-110.423 21.545-129.5 44-18.8 22.129-12.181 40.943 2.353 62.544z",
				fill: "#A5E7DB",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M542.774 243.239c.551 7.169-.062 14.859-3.08 21.929-.165-8.344-1.447-15.886-3.077-22.225a40.86 40.86 0 00-16.918 4.191c-.595.292-1.196.6-1.802.923 3.483 6.774 6.071 14.639 5.843 22.853-3.252-7.789-7.267-14.397-11.15-19.727-5.787 3.734-11.727 8.62-16.879 14.24 4.523 4.727 8.48 10.392 10.642 16.965-4.699-5.136-9.614-9.34-14.255-12.732-6.224 7.862-10.674 16.826-11.184 25.931 6.434-1.426 13.334 1.812 16.463 8.184 3.187 6.49 1.408 14.088-3.876 18.262 7.408 5.501 16.951 7.528 26.74 7.4.673-5.642.867-12.146-.025-19.052 3.951 5.567 5.524 12.27 5.866 18.731 7.255-.689 14.44-2.413 20.788-4.639-1.361-6.117-3.774-13.396-8.033-20.712 7.088 4.498 11.475 11.49 14.188 18.288a74.45 74.45 0 002.816-1.309 40.847 40.847 0 0013.641-10.799 75.657 75.657 0 00-17.203-16.961c8.654 1.583 15.715 6.235 21.096 11.295 5.564-9.761 7.04-21.659 3.451-32.831-3.549 1.739-13.579 2.49-16.174 2.372 1.31-2.5 8.226-9.61 11.772-11.35.069-.035.141-.069.215-.102-6.697-10.854-17.844-17.636-29.865-19.125z",
				fill: "#AFBEFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M422.998 349.268c17.572-30.463 57.34-44.309 73.93-50.227l1.102 2.244c-16.731 4.874-55.392 22.186-71.042 52.708-13.516 26.361-9.457 52.786-4.349 67.623.504 1.464-.13 3.09-1.521 3.773-1.574.773-3.474.036-4.035-1.626-5.237-15.487-10.493-46.05 5.915-74.495z",
				fill: "#AFBEFF",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFC6EC",
				fillRule: "nonzero",
				d: "M175 427v-13h7l-2.154 13zM209 434.148v-13h6.5l-2 13z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M180 366.648c.4-10.4-3.5-60.5-3.5-66.5 4.5 1 11.4 1.5 21 1.5s17-1 20-1.5c2.5 17.5 5 56.7 5 61.5 0 4.8-4.333 46.519-6.5 60.352h-7.5c.167-10.667.4-52.152 0-55.352-.4-3.2-7.333-28.166-11-36-1 4.834-3.5 30.8-3.5 36 0 5.2-7.667 36.167-11.5 51H175c-.167-12.666 4.6-40.6 5-51z",
				fill: "#546ACD",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M183 127.148l14.5 2c-.5 1.834-2.7 5.5-7.5 5.5s-6.667-5-7-7.5z",
				fill: "url(#g)",
				fillRule: "nonzero",
				transform: "translate(0 201)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M175 209.841c.333-1 1.7-3.4 4.5-5 3.5-2 10-2.5 11.5 0 1.029 1.715 1 3.5-1.5 5-2.312 1.387-10.609 3.629-11.055 4.75.223.342.275.47.055.25-.075-.075-.091-.159-.055-.25-.586-.904-2.357-3.3-3.445-4.75zM248 317.343c.321 1.017 1.635 3.457 4.328 5.084 3.366 2.034 9.616 2.542 11.059 0 .99-1.744.962-3.559-1.443-5.084-2.223-1.41-10.202-3.69-10.631-4.829.214-.349.264-.479.053-.255a.228.228 0 00-.053.255c-.564.918-2.267 3.355-3.313 4.829z",
				fill: "#FFC6EC",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M189 232.148v9.5c1.167.5 2.5 1.5 6.5 1.5s5.667-1 6.5-1.5l-1.5-4.5c.333-.333 1.6-1 4-1s4-7.666 4.5-10.5c-.5-.833-1.5-1.6-1.5-6 0-11-5.5-16-13-16s-9 12-9 14.5 3.5 10 3.5 14z",
				fill: "#FFC6EC",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M196 234.648c-2.4.8-6.667.334-8.5 0-1.5 0-1.373-4.841-2-8-.92-4.632-1.5-9-1.5-12s1.5-13.5 12-13.5c8.4 0 11.833 7.334 12.5 11 0 2.334-.8 7.1-4 7.5-3.2.4-5 3.5-5.5 5 0 3-.6 9.2-3 10z",
				fill: "#FFAB00",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M145 238.148c0 12.5 20.333 21 31 30.5v34c2.5 10.5 10.6 11.5 21 11.5s19-11 21.5-11.5c-1-8.166-3.8-30.7-3-29.5 1 1.5 6.954 18.269 14.5 28 5.839 7.53 14 14.5 17.5 17l5-5s-14.817-18.604-18-25.5c-6-13-8.8-25.9-12-33.5-3.2-7.6-15.333-12.166-20-13 0 0-7.5 3-13.5 0-9.832 1.805-19.164-4.054-28-7 1-4.5 19.5-19.5 19.5-19.5l-4.5-6.5s-31 18.5-31 30z",
				fill: "#03153A",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M180.5 424.648H175c-.5 2.334-1.5 7.2-1.5 8 0 1 1.5 3.5 10.5 3.5s11-2 11-3.5-2-3-5.5-3c-2.8 0-7.167-3.333-9-5zM213.5 431.148h-4c-.667 2.5-1.9 7.8-1.5 9 .5 1.5 6.5 2 9 2s10 0 10-2-3-3.5-5.5-3.5c-2 0-6.167-3.666-8-5.5z",
				fill: "#B2C3FF",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
				filter: "url(#h)",
				transform: "rotate(8 -78.013 1293.158)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						stroke: "#F1F4FA",
						fill: "#FFF",
						x: .5,
						y: .5,
						width: 241,
						height: 57,
						rx: 10
					}),
					/* @__PURE__ */ _jsx("text", {
						fontFamily: "CarosSoft, Caros Soft",
						fontSize: 14,
						fill: "#515061",
						transform: "translate(11 21)",
						children: /* @__PURE__ */ _jsx("tspan", {
							x: 48,
							y: 13,
							children: "Texte long"
						})
					}),
					/* @__PURE__ */ _jsx("rect", {
						width: 36,
						height: 36,
						rx: 10,
						fill: "#546ACD",
						transform: "translate(11 11)"
					}),
					/* @__PURE__ */ _jsxs("g", {
						fill: "#FFF",
						children: [/* @__PURE__ */ _jsx("path", { d: "M23.194 20h11.612A3.194 3.194 0 0138 23.194v11.612A3.194 3.194 0 0134.806 38H23.194A3.194 3.194 0 0120 34.806V23.194A3.194 3.194 0 0123.194 20zm0 1.742c-.802 0-1.452.65-1.452 1.452v11.612c0 .802.65 1.452 1.452 1.452h11.612c.802 0 1.452-.65 1.452-1.452V23.194c0-.802-.65-1.452-1.452-1.452H23.194z" }), /* @__PURE__ */ _jsx("path", { d: "M32.077 26h-6.154c-.51 0-.923.448-.923 1s.413 1 .923 1h6.154c.51 0 .923-.448.923-1s-.413-1-.923-1zm0 4h-6.154c-.51 0-.923.448-.923 1s.413 1 .923 1h6.154c.51 0 .923-.448.923-1s-.413-1-.923-1z" })]
					}),
					/* @__PURE__ */ _jsx("g", {
						fill: "#E5E9F0",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("path", { d: "M225 33.5c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5.675-1.5 1.5-1.5 1.5.675 1.5 1.5zm-1.5-6c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm0-4.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm4.5 3c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5zm0 1.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm0 4.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5z" })
					})
				]
			}) })
		]
	})]
});
export default SvgHomeEmpty;
